







































import { Vue, Component, Prop } from 'vue-property-decorator';
import { Slider, Toast } from 'vant';
Vue.use(Slider);

@Component({
  filters: {
    showtime: (value: number) => {
      let minutes = '';
      let seconds = '';
      const minute = value / 60;
      const min: number = Math.floor(minute);
      if (min < 10) {
        minutes = '0' + min;
      } else {
        minutes = min.toString();
      }
      const second: number = value % 60;
      const sec: number = Math.round(second);
      if (sec < 10) {
        seconds = '0' + sec;
      } else {
        seconds = sec.toString();
      }
      return minutes + ':' + seconds; // 过滤进度时间显示
    },
  },
})
export default class Audio extends Vue {
  @Prop() AudioSrc!: '';
  value = 0;
  showtime: string = '00:00';
  time: string = '00:00';
  stop = true;
  max: number = 100;
  audiotime: number = 0;
  int: number = 0;
  audioEle!: HTMLAudioElement;
  disabled: boolean = true;

  // 音频节点
  created() {
    this.timer(this.time); // 获取时间总长度（秒）
  }
  mounted() {
    this.audioEle = this.$refs.audio as HTMLAudioElement;
    this.audiotimer();
  }
  timer(time: string) {
    const min = time.split(':')[0];
    const sec = time.split(':')[1];
    const max = Number(min) * 60 + Number(sec);
    this.max = max ? 0 : 100; // 音频的总时间转换为秒
  }
  audiotimer() {
    const th = this;
    const myAudio = this.audioEle;
    if (myAudio) {
      myAudio.oncanplay = () => {
        this.disabled = false;
        let minutes = '';
        let seconds = '';
        const md = myAudio.duration;
        th.max = md;
        const minute = md / 60;
        const min: number = Math.floor(minute);
        if (min < 10) {
          minutes = '0' + min;
        } else {
          minutes = min.toString();
        }
        const second: number = md % 60;
        const sec: number = Math.round(second);
        if (sec < 10) {
          seconds = '0' + sec;
        } else {
          seconds = sec.toString();
        }
        th.time = minutes + ':' + seconds; // 获取音频的总时间
      };
    }
  }

  onDrag(value: number) {
    this.audioEle.currentTime = value; // 拖动按钮
  }
  onStop(a: number) {
    // 暂停和播放
    enum Direction {
      Start = 1,
      Stop,
    }
    if (a === Direction.Stop) {
      // 暂停
      this.stop = true;
      this.audioEle.pause();
      this.cleartime();
    } else if (a === Direction.Start && this.audioEle.duration) {
      console.log(this.audioEle.duration);
      // 播放
      this.stop = false;
      this.audioEle.play();
      this.value = this.audioEle.currentTime;
      console.log(this.audioEle.currentTime);
      if (this.max > this.value) {
        console.log(this.max, this.value);
        this.int = setInterval(() => {
          // 定时器
          this.value += 1;
          if (this.max < this.value) {
            this.cleartime();
            this.stop = true;
          }
        }, 1000);
      }
    }
  }
  onChangeTime(a: number) {
    // 快进和后退（10秒）
    enum Direction {
      Left = 3,
      Right,
    }
    if (a === Direction.Left && this.audioEle.duration) {
      // 后退
      this.audioEle.currentTime = this.audioEle.currentTime - 10;
      this.value = this.audioEle.currentTime;
    } else if (this.audioEle.duration && Direction.Right) {
      // 快进
      this.audioEle.currentTime = this.audioEle.currentTime + 10;
      this.value = this.audioEle.currentTime;
    }
  }

  cleartime() {
    // 清楚定时器
    window.clearInterval(this.int);
  }
}
